import React, { Component } from 'react';
import './scroll-bottom.css';

class ScrollToBottom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yAxisPageValue: 0
    };
    this.scrollHandler = this.scrollHandler.bind(this);
    this.scrollBottom = this.scrollBottom.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
  };
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  };

  scrollHandler() {
    this.setState(state => ({
      yAxisPageValue: window.pageYOffset
    }));
  }

  scrollBottom() {  
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    this.setState(state => ({
      showArrowIcon: !this.state.showArrowIcon
    }));
  }

  render() {
    if(this.state.yAxisPageValue > 30) {
      return (
        <div className="DownWrapper">
          <img src={require('../assets/up.png')} 
               alt="up arrow button"
               className="down-logo-img" 
               onClick={this.scrollBottom} />
        </div>
      )
    }
    
    return null;
  }
}

export default ScrollToBottom;